var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgZoomIn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 7,
    viewBox: "0 0 7 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.83998 6.06679L5.20339 4.4302C5.57556 3.87769 5.75918 3.18737 5.66087 2.4518C5.49366 1.20008 4.46754 0.182171 3.21487 0.0235712C1.35269 -0.212142 -0.212804 1.35363 0.0237295 3.21472C0.18233 4.46766 1.20052 5.49391 2.45195 5.66072C3.18767 5.75903 3.87799 5.57547 4.43035 5.20324L6.06694 6.83983C6.28051 7.05339 6.62683 7.05339 6.84039 6.83983C7.05327 6.62736 7.05327 6.28008 6.83998 6.06679ZM3.93732 3.17233H3.15936V3.93799C3.15936 4.11929 3.01252 4.26613 2.84353 4.26613C2.66169 4.26613 2.51539 4.11983 2.51539 3.93799V3.17233H1.73743C1.56789 3.17233 1.4216 3.02604 1.4216 2.84419C1.4216 2.66235 1.56844 2.51606 1.73743 2.51606H2.51539V1.7504C2.51539 1.5691 2.66223 1.42226 2.83123 1.42226C3.00022 1.42226 3.15936 1.56856 3.15936 1.7504V2.51606H3.92502C4.11917 2.51606 4.26546 2.66235 4.26546 2.84419C4.26546 3.02604 4.11917 3.17233 3.93732 3.17233Z",
    fill: "#F0F0F0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomIn);
export default __webpack_public_path__ + "static/media/zoom-in.f9c5cc31b96577ccd65628daef000bcf.svg";
export { ForwardRef as ReactComponent };